import { render } from "./add-provident-fund.vue?vue&type=template&id=45e45638"
import script from "./add-provident-fund.vue?vue&type=script&lang=js"
export * from "./add-provident-fund.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__